<!-- <div class="engie-home">
    <div class="engie-accesos">
          <div class="container">
            <div class="row items-accesos">
                <div class="box">
                        <h5><p>Acceso Denegado</p></h5>
                    
                </div>
            </div>
</div>
</div>
</div> -->
<img class="img-center" src="./assets/img/denegado.png">
<!-- <div class="engie-accesdenied"></div> -->
